import axios, { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi";

export const getMoodleFile = async (url: any) => {
  try {
    const moodleToken = sessionStorage?.getItem("wstoken");
    const response = await axios.get(url, {
      params: { token: moodleToken },
      responseType: "blob",
    });
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getFileContextId = async (filename: string) => {
  try {
    const response = await moodleInstanceApi.get(
      `/webservice/rest/server.php`,
      {
        params: {
          wsfunction: "core_files_get_file_contextid",
          component: "user",
          filearea: "draft",
          filepath: "/",
          filename: filename,
          itemid: 123456789123,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const uploadFileToMoodle = async (params: any) => {
  const { contextid, component, filearea, itemid, filepath, filename, file } =
    params;

  try {
    // ✅ Lấy token
    const token = sessionStorage.getItem("wstoken");
    if (!token) {
      throw new Error("Missing Moodle API Token");
    }

    const formData = new FormData();
    formData.append("token", token);
    formData.append("filepath", filepath);
    formData.append("filename", filename);
    formData.append("contextid", contextid);
    formData.append("component", component);
    formData.append("filearea", filearea);
    formData.append("itemid", itemid);
    formData.append("file", file);

    const response = await moodleInstanceApi.post(
      `/webservice/upload.php?moodlewsrestformat=json`,
      formData
    );

    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const deleteFileFromMoodle = async (params: any) => {
  const { contextid, component, filearea, itemid, filepath, filename } = params;

  try {
    const token = sessionStorage.getItem("wstoken");
    if (!token) {
      throw new Error("Missing Moodle API Token");
    }
    const response = await moodleInstanceApi.get(
      `/webservice/rest/server.php`,
      {
        params: {
          wstoken: token,
          wsfunction: "local_file_delete_delete_file",
          component: component,
          contextid: contextid,
          filearea: filearea,
          filename: filename,
          filepath: filepath,
          itemid: itemid,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};
